import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { TbArrowLeft } from "react-icons/tb";
import { backButtonAction } from "../../utils/navigationHistory";
import "./PageBackButton.css";

// Tüm panel sayfalarının üstündeki "← Geri" butonu (App.js Layout'unda TEK yerde çizilir).
// Doğrudan bir önceki sayfaya döner (navigate(-1)). Girişten hemen sonraki sayfada (önceki kayıt
// giriş/kayıt ekranı — giriş ekranı açılınca oturum düşer) buton hiç GÖSTERİLMEZ. Önceki sayfa
// bilinmiyorsa anasayfaya götürür; o durumda anasayfadaysa yine gösterilmez.
// Kurallar: utils/navigationHistory.js backButtonAction (geçmiş kaydını App.js Layout tutar).
export default function PageBackButton() {
  const navigate = useNavigate();
  // useLocation: her gezinmede yeniden çizilsin (history.state o anda güncellenmiş olur).
  const location = useLocation();
  const action = backButtonAction(window.history.state, location.pathname);

  if (!action) return null;

  const handleClick = () => {
    if (action === "back") navigate(-1);
    else navigate("/homepage");
  };

  return (
    <div className="page-back-bar">
      <button type="button" className="page-back-button" onClick={handleClick}>
        <TbArrowLeft size={16} /> Geri
      </button>
    </div>
  );
}
